module.exports = __webpack_public_path__ + "static/media/wn_5closeupbodyIMG_3529.267e1382.jpg";